import { render, staticRenderFns } from "./EstateCostCalculator.vue?vue&type=template&id=72690f06&scoped=true"
import script from "./EstateCostCalculator.vue?vue&type=script&lang=js"
export * from "./EstateCostCalculator.vue?vue&type=script&lang=js"
import style0 from "./EstateCostCalculator.vue?vue&type=style&index=0&id=72690f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72690f06",
  null
  
)

export default component.exports